// Authorization section form field enum
export enum AuthorizationFormField {
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE = 'authorization/authorization/authorization-source'
}
